<template>
  <div>
    <!-- Yeni: şablon sıfırdan oluşturulur (yönetici panelindeki gibi); kütüphaneden ekleme ikincil seçenek olarak kalır -->
    <a class="float-right m-2" href="javascript:;" data-test="new-template" @click="createNew"><i class="mdi mdi-plus" /> {{ $t("legal-document-template.new") }}</a>
    <right-panel class="float-right" id="add-legal-document-panel" width="600px" :icon="'mdi mdi-library'" :text="$t('legal-document-template.add-from-library')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <h3>{{ $t("legal-document-template.add") }}</h3>

        <LibraryItems
          :hideSaveAs="true"
          rightPanelId="add-legal-document-panel"
          :languageFilterEnabled="true"
          :multiSelectEnabled="true"
          organizationScopedState="organizationLegalDocumentTemplate"
          libraryScopedState="legalDocumentTemplate"
          @interceptForSetParent="interceptForSetParent"
          libraryScopedStateCategory="legalDocumentTemplateCategory"
          :query="libraryItemQuery"
        />
      </div>
    </right-panel>
    <table class="table table-bordered">
      <thead class="bg-dark text-white">
        <tr>
          <!-- <th class="text-center align-middle">
            <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
              <template #button-content>
                <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all") }}</b>
              </template>

              <b-dropdown-item href="#" @click="multipleSelect(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                <i class="bx bxs-file-blank text-primary" v-b-tooltip.hover :title="$t('legal-document-template.prepare')"></i> {{ $t("legal-document-template.prepare") }} ({{
                  selectedItems.length
                }})
              </b-dropdown-item>
            </b-dropdown>
          </th> -->
          <th class="text-center align-middle">
            <div>{{ $t("common.language") }} <LanguageFilter style="padding-bottom:0px;margin-bottom:0px;" :request="request" @changed="languageFilterChanged" /></div>
          </th>
          <th class="align-middle">
            <div>{{ $t("legal-document-template.name") }}</div>
          </th>
          <th class="align-middle">{{ $t("common.category") }}</th>
          <th class="align-middle">{{ $t("common.description") }}</th>
          <th class="align-middle">{{ $t("legal-document-template.filters.title") }}</th>
          <th class="align-middle" style="width: 80px;">{{ $t("legal-document-template.filters.is-provided") }}</th>
          <th class="align-middle">
            <a href="javascript:;" @click="toggleFilter">
              <span v-if="filterEnabled" class="text-warning">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-hide") }}
              </span>
              <span v-else class="text-white">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-show") }}
              </span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filterEnabled">
          <th></th>

          <th><input class="form-control" v-model="nameFilter" /></th>
          <th>
            <filter-select
              id="categoryFilter"
              ref="categoryFilter"
              :placeholder="$t('legal-document-template-category.text')"
              :multiple="false"
              :selected="categoryFilter"
              @filter="onCategorySearch"
              @changed="onCategorySelect"
            />
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <template v-if="pagination">
          <tr v-for="item in pagination.docs" :key="item._id">
            <!-- <td>
              <div class="text-center">
                <b-form-checkbox
                  v-if="item.isRequiredCriteriasProvided && !item.isRendering"
                  v-model="selectedItems"
                  :value="item"
                  class="custom-checkbox-primary mb-3 "
                  checked
                ></b-form-checkbox>
              </div>
            </td> -->
            <td>
              <language-badge :langCode="item.language" />
            </td>
            <td>
              <span v-if="item.isRendering">
                <i class="bx bx-hourglass bx-spin font-size-16 align-middle mr-2"></i>
              </span>
              {{ item.name | translate }}
            </td>
            <td>{{ item.category.name | translate }}</td>
            <td>{{ item.description | translate }}</td>
            <td>
              <ul style="list-style: none;margin:0px;padding:0px">
                <li v-for="criteria in normalizeFilterNames(item).required" :key="criteria.text" class="mb-2">
                  <i v-if="criteria.provided" class="bx bx-check-circle text-success"></i>
                  <i v-else class="bx bx-x-circle text-danger"></i>
                  <b> {{ criteria.text }}</b>

                  <ol v-if="criteria.value">
                    <li v-for="(v, i) in criteria.value" :key="i + v">{{ v | translate }}</li>
                  </ol>
                </li>
              </ul>

              <div v-if="normalizeFilterNames(item).others.length > 0">
                <h6 class="mt-3 mb-2">{{ $t("legal-document-template.filters.other-title") }}</h6>

                <ul style="list-style: none;margin:0px;padding:0px">
                  <li v-for="criteria in normalizeFilterNames(item).others" :key="criteria.text" class="mb-2">
                    <b> {{ criteria.text }}</b>
                    <ol v-if="criteria.value">
                      <li v-for="(v, i) in criteria.value" :key="i + v">{{ v | translate }}</li>
                    </ol>
                  </li>
                </ul>
              </div>
            </td>

            <td :class="item.isRequiredCriteriasProvided ? 'text-success' : 'text-muted'">{{ item.isRequiredCriteriasProvided ? $t("common.yes") : $t("common.no") }}</td>
            <td>
              <i class="bx bx-trash-alt text-danger hand mr-3 font-size-14" v-b-tooltip.hover :title="$t('common.delete')" @click="deleteById(item._id)"></i>
              <i class="bx bx-pencil text-warning hand mr-3 font-size-14" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
              <!-- TKP-200 m.22: bu ekran yalnız şablon yönetimi; metin "Yeni Metin" (sihirbaz) ekranından oluşturulur -->
            </td></tr
        ></template>
      </tbody>
    </table>
    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)" width="200px">
      <h4 class="text-center">{{ $t("common.no-data") }}</h4>
    </empty>
    <content-loading v-if="isLoading" />
    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import { normalizeCriteria } from "@/modules/legal-document/criteria";
import LanguageBadge from "@c/language-badge";
import LanguageFilter from "@c/language-filter";
import LibraryItems from "@cc/library-items";

const state = "organizationLegalDocumentTemplate";
export default {
  props: ["product"],
  components: { LibraryItems, LanguageBadge, LanguageFilter },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      categoryFilter: undefined,
      filterEnabled: false,
      selectedItems: [],
      filterNameMap: {
        organization: this.$t("legal-document-template.filters.organization"),
        department: this.$t("legal-document-template.filters.department"),
        process: this.$t("legal-document-template.filters.process"),
        dataCategory: this.$t("legal-document-template.filters.data-category"),
        data: this.$t("legal-document-template.filters.data"),
        datasubject: this.$t("legal-document-template.filters.datasubject"),
        directCollectMethod: this.$t("legal-document-template.filters.direct-collection-method"),
        otherCollectMethod: this.$t("legal-document-template.filters.other-collection-method"),
        electronicStorage: this.$t("legal-document-template.filters.electronic-storage"),
        physicalStorage: this.$t("legal-document-template.filters.physical-storage"),
        transferingPurpose: this.$t("legal-document-template.filters.transfering-purpose"),
        transferingLegalReason: this.$t("legal-document-template.filters.transfering-legal-reason"),
        transferingMethod: this.$t("legal-document-template.filters.transfering-method"),
        receiverGroup: this.$t("legal-document-template.filters.receiver-group"),
        thirdParty: this.$t("legal-document-template.filters.third-party"),
        // transferingDirection: this.$t("legal-document-template.filters.transfering-direction"),
        // transferingAbroad: this.$t("legal-document-template.filters.transfering-abroad"),
      },
    };
  },
  computed: {
    libraryItemQuery() {
      //!request'in payload'ına müdahale edilerek sistem specific kayıtlar görüntülenebilir ama bu kritik bir veri de değil
      return {
        products: { value: this.product, isObject: true },
        ...(this.currentAccount.type == "account"
          ? {
              $and: [{ $or: [{ isSystemSpecific: false }, { isSystemSpecific: { $exists: false } }] }],
            }
          : {}),
      };
    },
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    isLoading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    hasUnworkedPermission() {
      if (this.currentAccountCan("LEGAL_DOCUMENT_LEGAL_DOCUMENT_TEMPLATE_VIEW__HAS_UNWORKED_PERMISSION")) {
        return true;
      }

      return false;
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
  },
  watch: {
    request: {
      deep: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    categoryFilter(n, o) {
      if (n && n._id) {
        this.request.query = { ...this.request.query, category: { value: n._id, isObject: true } };
      } else {
        this.request.query["category"] = null;
        delete this.request.query["category"];
      }
    },
  },
  mounted() {
    if (this.product) {
      this.request = { ...this.request, query: { ...this.request.query, products: { value: this.product, isObject: true } } };
    }
  },
  methods: {
    // selectAllItems() {
    //   if (this.selectedItems.length > 0) {
    //     this.selectedItems = [];
    //   } else {
    //     this.selectedItems = this.pagination.docs.filter((i) => i.isRequiredCriteriasProvided && !i.isRendering);
    //   }
    // },

    // async multipleSelect(selectedItems) {
    //   const ok = await this.confirm(this.$t("alert.approve"));
    //   if (!ok) {
    //     return;
    //   }

    //   try {
    //     this.selectedItems.forEach((element, i) => {
    //       this.prepare(element, false);
    //     });
    //     this.$root.$emit("bv::show::modal", "modal-multiple-delete-operation");
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    async paginate() {
      await this.$store.dispatch(`${state}/paginate`, this.request);
      this.selectedItems = [];
    },
    languageFilterChanged(e) {
      this.request = e;
    },
    createNew() {
      this.$router.push(`/${this.product.toLowerCase()}/legal-document-template/create`);
    },
    async edit(item) {
      this.$router.push(`/${this.product.toLowerCase()}/legal-document-template/${item._id}`);
    },

    async prepare(item, confirm = true) {
      try {
        if (confirm) {
          const ok = await this.confirm(this.$t("alert.approve"));
          if (!ok) {
            return;
          }
        }

        await this.$store.dispatch(`${state}/prepare`, item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationLegalDocumentTemplateCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onCategorySelect(category) {
      if (category?._id == this.categoryFilter?._id) {
        return;
      }

      this.categoryFilter = { ...category };
    },

    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, id);
        this.paginate();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    normalizeFilterNames(item) {
      return normalizeCriteria(item.requiredCriterias, item.criteria, this.filterNameMap); // TKP-27 / 6.4c-3
    },

    // normalizeFilterNames(item) {
    //   return item.requiredCriterias.map((i) => this.filterNameMap[i]).join(", ");
    // },
    interceptForSetParent(payload) {},
    rightPanelClosed() {
      this.paginate();
    },
  },
};
</script>
